module.exports = __webpack_public_path__ + "static/media/img_mistral.b59f0fbe.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/brand/cards-benefits/img_mistral.png
// module id = 671
// module chunks = 10